import { render, staticRenderFns } from "./SubFormulario.vue?vue&type=template&id=53140ab2&scoped=true"
import script from "./SubFormulario.vue?vue&type=script&lang=js"
export * from "./SubFormulario.vue?vue&type=script&lang=js"
import style0 from "./SubFormulario.vue?vue&type=style&index=0&id=53140ab2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53140ab2",
  null
  
)

export default component.exports